export default __webpack_public_path__ + "175a131893991c89b134949aaafb0de1.glb";